import React from 'react'; //import React Component

export function Error() {

    return (
        <div id="Error">
            <div className='Error'>
                <div style={{ textAlign: "center" }}>
                    <h1 style={{ fontSize: "60px" }}>404</h1>
                    <p>This is not a right path for Enrich Culture website</p>
                </div>
            </div>
        </div>
    );
}